export const redirectToLogin = () => {
  try {
    localStorage.removeItem('token');
  } catch (error) {
    // Ignore storage access issues during redirect
  }
  window.location.replace('/');
};

export const handleForbiddenResponse = (response) => {
  if (response && response.status === 403) {
    redirectToLogin();
    return true;
  }
  return false;
};
